import MutationTypes from './mutation-types'
import {
  getCartskuIndexByid
} from '@/common/miscutil'
import {sysUtil} from "jscom/utils/sysutil"

export function _getSellerCartMap (state) {
  if (state.appType === 'seller' && state.operationStatus.custom.customid > 0) {
    let customid = state.operationStatus.custom.customid
    if (state.sellerCartMap[customid]) {
      return state.sellerCartMap[customid]
    }
    return []
  } else {
    return state.cartList
  }
}
export function _setSellerCartMap (state, shoppingCart) {
  if (state.appType === 'seller' && state.operationStatus.custom.customid > 0) {
    let customid = state.operationStatus.custom.customid
    let sellerCartMap = state.sellerCartMap
    if (shoppingCart.length === 0) {
      delete sellerCartMap[customid]
    } else {
      sellerCartMap[customid] = shoppingCart
    }
    state.sellerCartMap = {...sellerCartMap}
    sysUtil.setLocalStore('sellerCartMap', state.sellerCartMap)
  } else {
    state.cartList = [...shoppingCart]
    sysUtil.setLocalStore('shoppingCart', state.cartList, true)
  }
}

export default {
  [MutationTypes.SET_USEROAUTH] (state, userOauth) {
    Object.assign(state.userOauth, userOauth)
    state.userOauth = {...state.userOauth}
    sysUtil.setLocalStore('userOauth', state.userOauth)
  },

  [MutationTypes.INIT_USEROAUTH] (state) {
    let strUserOauth = sysUtil.getLocalStore('userOauth')
    if (!strUserOauth) {
      strUserOauth = sysUtil.getLocalStore('userInfo')
      if (strUserOauth && strUserOauth.indexOf('access_token') !== -1) {
        sysUtil.removeLocalStore('userInfo')
        sysUtil.setLocalStore('userOauth', strUserOauth)
      } else {
        console.warn('cannot get userOauth from local store')
        return
      }
    }

    state.userOauth = JSON.parse(strUserOauth)
    if (!state.userOauth) {
      state.userOauth = {}
    }
  },

  [MutationTypes.CLEAR_USEROAUTH] (state) {
    state.userOauth = {}
    sysUtil.removeLocalStore('userOauth')
  },

  [MutationTypes.SET_CONFIG] (state, config) {
    state.config = config
  },

  [MutationTypes.SET_SELLER_CONFIG] (state, config) {
    state.sellerConfig = config
  },

  [MutationTypes.SET_USERINFO] (state, userInfo) {
    state.userInfo.data = userInfo
  },

  [MutationTypes.CLEAR_USERINFO] (state) {
    state.userInfo.data = null
  },

  [MutationTypes.INIT_OPENID] (state) {
    let openid = sysUtil.getLocalStore('openid')
    if (!openid) {
      console.info('cannot get openid from local store')
      return
    }

    state.openid = openid
    if (!state.openid) {
      state.openid = ''
    }
  },

  [MutationTypes.SET_OPENID] (state, openid) {
    state.openid = openid
    sysUtil.setLocalStore('openid', state.openid)
  },

  [MutationTypes.CLEAR_OPENID] (state) {
    state.openid = ''
    sysUtil.removeLocalStore('openid')
  },

  [MutationTypes.INIT_OPERATION_STATUS] (state) {
    let strStatus = sysUtil.getLocalStore('operationStatus', true)
    if (!strStatus) {
      console.info('cannot get operation status from local store')
      return
    }

    state.operationStatus = JSON.parse(strStatus)
    if (!state.operationStatus) {
      state.operationStatus = {}
    }
  },

  // [opValue: object]: {OPKEY: OPVALUE}
  [MutationTypes.SET_OPERATION_STATUS] (state, opValue) {
    let operationStatus = state.operationStatus
    Object.assign(operationStatus, opValue)
    state.operationStatus = {...operationStatus}
    sysUtil.setLocalStore('operationStatus', state.operationStatus, true)
  },

  [MutationTypes.DELETE_OPERATION_STATUS] (state, opKey) {
    if (state.operationStatus[opKey]) {
      delete state.operationStatus[opKey]
      sysUtil.setLocalStore('operationStatus', state.operationStatus, true)
    }
  },

  [MutationTypes.CLEAR_OPERATION_STATUS] (state) {
    state.operationStatus = {}
    sysUtil.removeLocalStore('operationStatus', true)
  },

  [MutationTypes.SET_SHOPPINGCART] (state, cartList) {
    if (cartList) {
      state.cartList = cartList
    } else {
      state.cartList = []
    }
    _setSellerCartMap(state, cartList)
  },
  [MutationTypes.ADD_SHOPPINGCART] (state, cartSku) {
    let shoppingCart = _getSellerCartMap(state, cartSku)
    let index = getCartskuIndexByid(shoppingCart, cartSku.skuid)
    if (index !== -1) {
      shoppingCart[index].count += cartSku.count
    } else {
      state.cartList.push(cartSku)
    }
    _setSellerCartMap(state, shoppingCart)
  },
  [MutationTypes.REDUCE_SHOPPINGCART] (state, cartSku) {
    let shoppingCart = _getSellerCartMap(state, cartSku)
    let index = getCartskuIndexByid(shoppingCart, cartSku.skuid)
    if (index !== -1) {
      shoppingCart[index].count -= cartSku.count
      if (shoppingCart[index].count < 1) {
        shoppingCart.splice(index, 1)
      }
    }
    _setSellerCartMap(state, shoppingCart)
  },
  [MutationTypes.UPDATE_SHOPPINGCART] (state, cartSku) {
    let shoppingCart = _getSellerCartMap(state, cartSku)
    let index = getCartskuIndexByid(shoppingCart, cartSku.skuid)
    console.log('cartList: ' + JSON.stringify(shoppingCart))
    if (index === -1 && cartSku.count === 0) {
      console.warn('cannot find sku:' + cartSku.skuid)
      return
    }
    if (cartSku.count === 0) {
      shoppingCart.splice(index, 1)
      console.warn('splice cartList: ' + JSON.stringify(shoppingCart))
    } else {
      index === -1 ? shoppingCart.push(cartSku) : shoppingCart[index] = cartSku
    }
    _setSellerCartMap(state, shoppingCart)
  },
  [MutationTypes.REMOVE_SHOPPINGCART] (state, skuList) {
    let shoppingCart = _getSellerCartMap(state, skuList)
    let updated = false
    console.log('remove cartitem: ' + JSON.stringify(skuList))
    for (let skuItem of skuList) {
      let index = getCartskuIndexByid(shoppingCart, skuItem.skuid)
      if (index !== -1) {
        updated = true
        shoppingCart.splice(index, 1)
      }
    }
    if (updated) {
      console.log('update cart: ' + JSON.stringify(shoppingCart))
    }
    _setSellerCartMap(state, shoppingCart)
  },
  [MutationTypes.UPDATE_SHOPPINGCAR] (state, skuInfoList) {
    let customid = state.operationStatus.custom.customid
    let sellerCartMap = state.sellerCartMap[customid]
    for (let cartSku of sellerCartMap) {
      for (let sku of skuInfoList) {
        if (cartSku.skuid === sku.skuid) {
          cartSku.ss_price = sku.price
          cartSku.storeCount = sku.storeCount
          cartSku.canSellCount = sku.canSellCount
        }
      }
    }
    state.sellerCartMap[customid] = sellerCartMap
    sysUtil.setLocalStore('sellerCartMap', state.sellerCartMap)
  },
  [MutationTypes.CLEAR_SHOPPINGCART] (state) {
    if (state.appType === 'seller') {
      state.sellerCartMap = {}
      sysUtil.removeLocalStore('sellerCartMap')
    } else {
      state.cartList = []
      sysUtil.removeLocalStore('shoppingCart', true)
    }
  },

  [MutationTypes.INIT_ORDER_PAYMETHOD] (state) {
    let paymethods = sysUtil.getLocalStore('orderPaymethods')
    if (!paymethods) {
      console.info('cannot get paymethods from local store')
      return
    }

    state.lastPaymethods = JSON.parse(paymethods)
    if (!state.lastPaymethods) {
      state.lastPaymethods = {}
    }
  },

  // [pmValue: object]: {contractid: paymethod}
  [MutationTypes.SET_ORDER_PAYMETHOD] (state, pmValue) {
    let lastPaymethods = state.lastPaymethods
    Object.assign(lastPaymethods, pmValue)
    state.lastPaymethods = {...lastPaymethods}
    sysUtil.setLocalStore('orderPaymethods', state.lastPaymethods)
  },

  [MutationTypes.CLEAR_ORDER_PAYMETHOD] (state) {
    state.lastPaymethods = {}
    sysUtil.removeLocalStore('orderPaymethods')
  },

  [MutationTypes.INIT_GET_WXCODE_STATUS] (state) {
    let isGetWxCode = sysUtil.getLocalStore('isGetWxCode', true)
    if (!isGetWxCode) {
      console.info('cannot get isGetWxCode from local store')
      return
    }

    try {
      state.isGetWxCode = JSON.parse(isGetWxCode)
    } catch (error) {
    }
  },

  [MutationTypes.SET_GET_WXCODE_STATUS] (state, isGet) {
    state.isGetWxCode = isGet
    sysUtil.setLocalStore('isGetWxCode', state.isGetWxCode, true)
  },

  [MutationTypes.SET_ORDERINFO] (state, orderInfo) {
    state.orderInfo = Object.assign({}, orderInfo)
    sysUtil.setLocalStore('orderInfo', state.orderInfo, true)
  },

  [MutationTypes.INIT_ORDERINFO] (state) {
    let strOrderItem = sysUtil.getLocalStore('orderInfo', true)
    if (!strOrderItem) {
      console.info('cannot get strOrderItem status from local store')
      return
    }
    state.orderInfo = JSON.parse(strOrderItem)
    if (!state.orderInfo) {
      state.orderInfo = {}
    }
  },

  [MutationTypes.CLEAR_ORDERINFO] (state) {
    state.orderInfo = {}
    sysUtil.removeLocalStore('orderInfo', true)
  },

  [MutationTypes.SET_BUYER_SHOPID] (state, buyerShopid) {
    state.buyerShopid = buyerShopid
    sysUtil.setLocalStore('buyerShopid', state.buyerShopid, true)
  },

  [MutationTypes.INIT_BUYER_SHOPID] (state) {
    let buyerShopid = sysUtil.getLocalStore('buyerShopid', true)
    if (!buyerShopid) {
      console.info('cannot get buyerShopid from local store')
      return
    }
    state.buyerShopid = JSON.parse(buyerShopid)
    if (!state.buyerShopid) {
      state.buyerShopid = 0
    }
  },

  [MutationTypes.CLEAR_BUYER_SHOPID] (state) {
    state.buyerShopid = 0
    sysUtil.removeLocalStore('buyerShopid', true)
  },

  [MutationTypes.SET_SELLER_CUSTOMID] (state, sellerCustomid) {
    state.sellerCustomid = sellerCustomid
    sysUtil.setLocalStore('sellerCustomid', state.sellerCustomid, true)
  },

  [MutationTypes.INIT_SELLER_CUSTOMID] (state) {
    let sellerCustomid = sysUtil.getLocalStore('sellerCustomid', true)
    if (!sellerCustomid) {
      console.info('cannot get sellerCustomid from local store')
      return
    }
    state.sellerCustomid = JSON.parse(sellerCustomid)
    if (!state.sellerCustomid) {
      state.sellerCustomid = 0
    }
  },

  [MutationTypes.CLEAR_SELLER_CUSTOMID] (state) {
    state.sellerCustomid = 0
    sysUtil.removeLocalStore('sellerCustomid', true)
  },

  [MutationTypes.INIT_SUPPLIER_SKU_MAP] (state) {
    let skuList = sysUtil.getLocalStore('supplierSkuMap')
    if (!skuList) {
      console.log('cannot get supplierSkuList')
      return
    }

    state.supplierSkuMap = JSON.parse(skuList)
  },

  [MutationTypes.SET_SUPPLIER_SKU_MAP] (state, skuMap) {
    state.supplierSkuMap = skuMap
    sysUtil.setLocalStore('supplierSkuMap', state.supplierSkuMap)
  },

  // skuItem: {SUPPLIERID: {SKUID: {count: COUNT, checked: true}}}
  [MutationTypes.UPDATE_SUPPLIER_SKU] (state, skuItem) {
    for (let supplierid in skuItem) {
      if (supplierid in state.supplierSkuMap) {
        Object.assign(state.supplierSkuMap[supplierid], skuItem[supplierid])
      } else {
        state.supplierSkuMap[supplierid] = skuItem[supplierid]
      }
    }
    state.supplierSkuMap = {...state.supplierSkuMap}
    sysUtil.setLocalStore('supplierSkuMap', state.supplierSkuMap)
  },

  [MutationTypes.CLEAR_SUPPLIER_SKU_CHECKED] (state) {
    let supplierMap = state.supplierSkuMap
    for (let customid in supplierMap) {
      let skuMap = supplierMap[customid]
      for (let skuid in skuMap) {
        skuMap[skuid].checked = false
      }
    }
    state.supplierSkuMap = {...supplierMap}
    sysUtil.setLocalStore('supplierSkuMap', state.supplierSkuMap)
  },

  [MutationTypes.CLEAR_SUPPLIER_SKU_MAP] (state) {
    state.supplierSkuMap = {}
    sysUtil.removeLocalStore('supplierSkuMap')
  }
}



// WEBPACK FOOTER //
// ./src/apps/baseapp/store/mutations.js